<template>
  <div class="impersonate-page">
    <a-spin />
    <p>{{ message }}</p>
  </div>
</template>

<script>
import { exchangeImpersonationTicket } from '@/api/impersonation'

const IMPERSONATION_KEY = 'erp_impersonation'
const IMPERSONATION_ACCESS_KEY = 'erp_impersonation_access'
const IMPERSONATION_REFRESH_KEY = 'erp_impersonation_refresh'
const LOGIN_PATH = '/user/login'

export default {
  name: 'Impersonate',
  data() {
    return {
      message: '正在进入 ERP 系统...',
    }
  },
  created() {
    this.exchangeTicket()
  },
  methods: {
    async exchangeTicket() {
      const ticket = this.$route.query.ticket
      if (!ticket) {
        this.message = '代登票据缺失'
        this.clearSession()
        this.redirectLogin()
        return
      }

      try {
        const data = await exchangeImpersonationTicket(ticket)
        const impersonation = data.impersonation || {}
        sessionStorage.setItem(IMPERSONATION_ACCESS_KEY, data.access)
        sessionStorage.setItem(IMPERSONATION_REFRESH_KEY, data.refresh)
        sessionStorage.setItem(IMPERSONATION_KEY, JSON.stringify(impersonation))
        this.$router.replace('/')
      } catch (e) {
        this.message = '代登票据无效或已过期'
        this.clearSession()
        this.redirectLogin()
      }
    },
    clearSession() {
      sessionStorage.removeItem(IMPERSONATION_ACCESS_KEY)
      sessionStorage.removeItem(IMPERSONATION_REFRESH_KEY)
      sessionStorage.removeItem(IMPERSONATION_KEY)
    },
    redirectLogin() {
      setTimeout(() => {
        this.$router.replace(LOGIN_PATH)
      }, 1200)
    },
  },
}
</script>

<style scoped>
.impersonate-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  color: #1f2933;
}
</style>
